<template>
  <div class="app">
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </div>

  <!-- Установка приложения -->
  <Install />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/authStore'
import Install from '@/components/Install.vue'

declare global {
  interface ScreenOrientation {
    lock(orientation: 'portrait' | 'landscape' | 'any'): Promise<void>
  }
}

const authStore = useAuthStore()

onMounted(async () => {
  authStore.initializeAuth()
})

</script>

<style>

</style>